import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

export type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

export interface ToastOptions {
  message: string;
  severity?: ToastSeverity;
  title?: string;
  life?: number;
  sticky?: boolean;
  closable?: boolean;
}

const DEFAULT_TITLES: Record<ToastSeverity, string> = {
  success: 'Éxito',
  info:    'Información',
  warn:    'Advertencia',
  error:   'Error',
};

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageService = inject(MessageService);

  show(options: ToastOptions): void {
    const severity = options.severity ?? 'info';
    this.messageService.add({
      severity,
      summary:  options.title    ?? DEFAULT_TITLES[severity],
      detail:   options.message,
      life:     options.life     ?? 4000,
      sticky:   options.sticky   ?? false,
      closable: options.closable ?? true,
    });
  }

  success(message: string, title?: string): void {
    this.show({ severity: 'success', message, title });
  }

  error(message: string, title?: string): void {
    this.show({ severity: 'error', message, title, life: 6000 });
  }

  warn(message: string, title?: string): void {
    this.show({ severity: 'warn', message, title });
  }

  info(message: string, title?: string): void {
    this.show({ severity: 'info', message, title });
  }
}
